import React from 'react';
import { FormattedMessage } from 'translations';
import classnames from 'classnames';
import { Layout, Flex } from 'app/components/base/Layout';
import style from './style.css';
import image from './img/location-not-covered.svg';


const messages = {
  noResultsMessage: { id: 'SEARCH_RESULTS.NO_RESULTS_MESSAGE' },
  noResultsReason: { id: 'SEARCH_RESULTS.NO_RESULTS_REASON' },
};


export const NoResultsLayout = ({
  className,
  mobile,
  ...props
}) => {
  const modifiers = {
    [style.mobile]: mobile
  };

  return (
    <Layout
      size="noshrink"
      direction="column"
      className={classnames(style.centered, style['no-results-container'], className, modifiers)}
      {...props}
    >

      <Layout align="center center" size="noshrink">
        <Flex size={20}>
          <img src={image} alt="Location not Covered" />
        </Flex>
      </Layout>

      <Layout align="start center" direction="column" size="noshrink">
        <h3 className={style.title}>
          <FormattedMessage {...messages.noResultsMessage} />
        </h3>
        <h4 className={style.subtitle}>
          <FormattedMessage {...messages.noResultsReason } />&nbsp;
        </h4>
      </Layout>
    </Layout>
  );
};

// TODO: move to Flow types
// NoResultsLayout.propTypes = {
//   className: PropTypes.string,
//   mobile: PropTypes.bool
// };

export default NoResultsLayout;
